import { createContext, useContext, useState, ReactNode } from 'react';
import { DashboardView } from '../utils/enums';

interface DashboardContextValue {
  view: DashboardView;
  setView: (view: DashboardView) => void;
}

const DashboardContext = createContext<DashboardContextValue | null>(null);

export const DashboardProvider = ({ children }: { children: ReactNode }) => {
  const [view, setView] = useState<DashboardView>(DashboardView.DASHBOARD);

  return (
    <DashboardContext.Provider value={{ view, setView }}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = (): DashboardContextValue => {
  const context = useContext(DashboardContext);
  if (!context) throw new Error('useDashboard must be used within DashboardProvider');
  return context;
};
